module.exports = __webpack_public_path__ + "img/Icon-Tableta.fb8036aa.svg";